const RECEIPT_CSS = `@page{size:58mm auto;margin:0}body{margin:0;padding:2mm;font-family:"Courier New",monospace;font-size:11px;line-height:1.35;color:#000;width:54mm}
.rc-row{display:flex;justify-content:space-between;gap:6px}.rc-row span:last-child{text-align:right}.rc-line{border-top:1px dashed #000;margin:5px 0}
.text-center{text-align:center}.font-bold{font-weight:bold}.text-base{font-size:13px}.text-sm{font-size:12px}.mb-1{margin-bottom:3px}.mt-1{margin-top:3px}.tracking-widest{letter-spacing:2px}`;

export const printHtml = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const frame = document.createElement("iframe");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  document.body.appendChild(frame);
  const doc = frame.contentWindow.document;
  doc.open();
  doc.write(`<!doctype html><html><head><title>Struk</title><style>${RECEIPT_CSS}</style></head><body>${el.innerHTML}</body></html>`);
  doc.close();
  frame.contentWindow.focus();
  frame.contentWindow.print();
  setTimeout(() => frame.remove(), 1000);
};
